import { Location } from '@libs/models/locations';
import { request } from '../request';

export function getLocation(id: string) {
  return request.get<LocationResponse>(`/v2/settings/locations/${id}`);
}
type LocationResponse = Location;
